
import { Component, Vue } from 'vue-property-decorator';
import GenericError from '@/components/common/Alerts/GenericError.vue';
import ResponsiveContainer from '@/components/Layout/ResponsiveContainer.vue';

@Component({ components: { GenericError, ResponsiveContainer } })
export default class ErrorView extends Vue {}
